// Slide configuration from Figma design
// Positions converted from absolute (1440x545) to percentages for responsiveness

// Desktop: All 9 slides
const SLIDES_DESKTOP = [
  { src: '/slides/slide-19.png', left: 2.2, top: 0, rotation: 5.94, zIndex: 1 },
  { src: '/slides/view-2.png', left: 1.67, top: 50.8, rotation: -4.77, zIndex: 2 },
  { src: '/slides/view-1.png', left: 63.96, top: 5.3, rotation: 4.65, zIndex: 3 },
  { src: '/slides/slide-23.png', left: 28.3, top: 16.3, rotation: -2.34, zIndex: 4 },
  { src: '/slides/slide-24.png', left: 17.9, top: 38.2, rotation: 2.7, zIndex: 5 },
  { src: '/slides/slide-27.png', left: 50, top: 34.5, rotation: -4.08, zIndex: 6 },
  { src: '/slides/view-5.png', left: 32.6, top: 59.1, rotation: 3.88, zIndex: 7 },
  { src: '/slides/view-3.png', left: 59.2, top: 58.2, rotation: 5.86, zIndex: 8 },
  { src: '/slides/view-4.png', left: 76.6, top: 28.6, rotation: -6.1, zIndex: 9 },
]

// Mobile: slides repositioned for vertical layout (desktop 60% size = ~55% width)
const SLIDES_MOBILE = [
  // Top row - extends beyond screen edges
  { src: '/slides/slide-19.png', left: -18, top: 4, rotation: 6, zIndex: 1 },
  { src: '/slides/view-1.png', left: 74, top: 1, rotation: 4.5, zIndex: 3 },
  // Middle-upper row
  { src: '/slides/slide-23.png', left: 25, top: 14, rotation: -2.5, zIndex: 5 },
  { src: '/slides/view-2.png', left: -8, top: 28, rotation: -4.5, zIndex: 2 },
  { src: '/slides/slide-27.png', left: 52, top: 32, rotation: -4, zIndex: 4 },
  // Middle-lower row
  { src: '/slides/slide-24.png', left: 12, top: 44, rotation: 2.7, zIndex: 6 },
  // Bottom row
  { src: '/slides/view-5.png', left: -12, top: 62, rotation: 4, zIndex: 7 },
  { src: '/slides/view-3.png', left: 48, top: 58, rotation: 5.5, zIndex: 8 },
]

export function SlideExplosion() {
  return (
    <>
      {/* Desktop Layout - container has min-width to maintain proportions on tablets */}
      <div className="hidden md:flex w-full overflow-x-clip overflow-y-visible justify-center">
        <div className="min-w-[1100px] w-full aspect-[1440/545] relative pointer-events-none">
          <DiggingHands variant="desktop" />
          {/* Shine effect overlay */}
          {/* <img
            src="/shine-center.jpg"
            alt=""
            className="shine-effect absolute mix-blend-lighten pointer-events-none opacity-0"
            style={{
              left: '50%',
              top: '0%',
              width: '60%',
              transform: 'translateX(-50%)',
              zIndex: 25,
            }}
          /> */}
          {SLIDES_DESKTOP.map((slide, index) => (
            <div
              key={index}
              className="slide-item absolute w-[24%] aspect-video"
              style={{
                left: `${slide.left}%`,
                top: `${slide.top}%`,
                transform: `rotate(${slide.rotation}deg)`,
                zIndex: slide.zIndex,
              }}
            >
              <img
                src={slide.src}
                alt={`Slide ${index + 1}`}
                className="w-full h-full object-cover rounded-sm shadow-soft"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Mobile Layout - container has min/max-width, centered horizontally, top-aligned */}
      <div className="md:hidden w-full overflow-x-clip overflow-y-visible flex justify-center items-start pt-12">
        <div className="min-w-[420px] max-w-[520px] w-full aspect-[1/2] relative pointer-events-none">
          <DiggingHands variant="mobile" />
          {/* Shine effect overlay */}
          {/* <img
            src="/shine-center.jpg"
            alt=""
            className="shine-effect absolute mix-blend-lighten pointer-events-none opacity-0"
            style={{
              left: '50%',
              top: '-5%',
              width: '90%',
              transform: 'translateX(-50%)',
              zIndex: 25,
            }}
          /> */}
          {SLIDES_MOBILE.map((slide, index) => (
            <div
              key={index}
              className="slide-item absolute w-[55%] aspect-video"
              style={{
                left: `${slide.left}%`,
                top: `${slide.top}%`,
                transform: `rotate(${slide.rotation}deg)`,
                zIndex: slide.zIndex,
              }}
            >
              <img
                src={slide.src}
                alt={`Slide ${index + 1}`}
                className="w-full h-full object-cover rounded-sm shadow-soft"
              />
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

// Hand illustrations with mix-blend-mode screen effect
// Variant: 'desktop' | 'mobile' for responsive positioning
function DiggingHands({ variant }: { variant: 'desktop' | 'mobile' }) {
  if (variant === 'mobile') {
    return (
      <>
        {/* Mobile: Main hand centered above slides (50% size) */}
        <img
          src="/left-hand.png"
          alt=""
          className="absolute mix-blend-screen pointer-events-none"
          style={{
            left: '62%',
            top: '1%',
            width: 'clamp(70px, 24vw, 100px)',
            transform: 'translateX(-50%)',
            zIndex: 20,
          }}
        />
        {/* Mobile: Second hand offset to left (50% size) */}
        <img
          src="/right-hand.png"
          alt=""
          className="absolute mix-blend-screen pointer-events-none"
          style={{
            left: '32%',
            top: '-4%',
            width: 'clamp(50px, 16vw, 75px)',
            transform: 'translateX(-50%)',
            zIndex: 20,
          }}
        />
      </>
    )
  }

  // Desktop layout (original)
  return (
    <>
      {/* Right Hand (larger, right side) */}
      <img
        src="/left-hand.png"
        alt=""
        className="absolute mix-blend-screen pointer-events-none"
        style={{
          right: '37%',
          top: '-11%',
          width: 'clamp(160px, 14vw, 200px)',
          zIndex: 20,
        }}
      />

      {/* Left Hand (smaller, left side) */}
      <img
        src="/right-hand.png"
        alt=""
        className="absolute mix-blend-screen pointer-events-none"
        style={{
          left: '30%',
          top: '-22%',
          width: 'clamp(110px, 10vw, 138px)',
          zIndex: 20,
        }}
      />
    </>
  )
}
